interface Stat {
  label: string;
  value: string;
  icon: string;
}

interface StatsSectionProps {
  stats: Stat[];
}

export default function StatsSection({ stats }: StatsSectionProps) {
  return (
    <section className="py-14 md:py-16 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-6xl">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${stat.icon} text-accent-600 text-lg`}></i>
              </div>
              <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}